module.exports = __webpack_public_path__ + "static/media/en-flag.b08cce47.png";